<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#007BFF" :is-full-page="true">
    </loading>
    <div class="container-fluid">
      <div class="card  pt-3">
        <div class="row starter-page">
          <div class="container-fluid ">
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="">
                <div class="d-inline-block">
                  <base-button type="success" @click="downloadExcel">Excel</base-button>
                </div>
                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur" :config="dates.config"
                      placeholder="Seleccione fecha" class="form-control datepicker" @input="dateRangeChange"
                      v-model="dates.range">
                    </flat-picker>
                  </base-input>
                </div>
              </div>
              <div>
                <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Buscar...">
                </base-input>
              </div>


            </div>
            <vue-content-loading v-if="!loaded" :width="300" :height="170" primary="#bdc3c7"
              secondary="#95a5a6">
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />


              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />

            </vue-content-loading>

            <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light" v-if="loaded"
              @sort-change="sortChange">

              <template v-slot:empty>
                  <span>No hay opiniones registradas</span>
              </template>

              <el-table-column v-for="column in tableColumns" :key="column.label" v-bind="column">
              </el-table-column>
              <el-table-column label="Opciones" prop="subgroup_id" width="230px">
                <template v-slot="{ row }">
                  <div class="justify-content-center justify-content-sm-between flex-wrap">
                    <a href="javascript:void(0);" @click="showDetails(row)" class="px-2">
                      <base-button :disabled="row.meal_status && [2, 3].includes(row.meal_status)" type="primary"
                        class="btn-sm">
                        Detalles
                      </base-button>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <CustomModal :is-modal="selectedFeedback != null" @closeModal="selectedFeedback = null" :closeOuth="true" width="xlg">
      <FoodcourtFeedback :feedback="selectedFeedback"></FoodcourtFeedback>
    </CustomModal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import BackofficeApi from "../../gateways/backoffice-api";
import { VueContentLoading } from 'vue-content-loading'
import flatPicker from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es'
import Loading from 'vue-loading-overlay';
import CustomModal from "../../components/CustomModal";
import FoodcourtFeedback from "./FoodcourtFeedback";
import 'vue-loading-overlay/dist/vue-loading.css';
import Fuse from 'fuse.js'
import { format, subDays, parse, addDays } from 'date-fns'

export default {
  name: "ListReviews",
  components: {
    // BasePagination,
    VueContentLoading,
    CustomModal,
    FoodcourtFeedback,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Loading
  },
  data() {
    return {
      loaded: false,
      selectedFeedback: null,
      searchQuery: '',
      searchedData: [],
      isLoading: false,
      tableColumns: [
        {
          prop: 'at',
          label: 'Fecha',
          minWidth: 125,
          sortable: true,

        },
        {
          prop: 'customer',
          label: 'Cliente',
          minWidth: 150,
          sortable: true
        },
        {
          prop: 'restaurant_qualification',
          label: 'Calificación',
          minWidth: 150,
          sortable: true
        },
      ],
      feedbacks: [],
      pageActual: 1,
      dates: {
        range: "",
        config: { allowInput: false, mode: 'range', locale: Spanish }
      },
      rangeDate: []
    }
  },
  async mounted() {
    this.dates.range = this.defaultDateRange.join(' a ');
    this.rangeDate = this.defaultDateRange;
    if (this.darkKitchenId) {
      await this.loadFeedback();
    }
  },
  computed: {
    darkKitchenId() {
      return this.$store.getters.getKitchenId;
    },
    excelName() {
      var frLocale = require('date-fns/locale/es');
      const formatedDates = this.rangeDate.map(date => {
        const parsed = parse(date, 'YYYY-MM-DD', new Date());
        return format(parsed, 'MMM DD', { locale: frLocale });
      });
      return `Opiniones ${formatedDates.join(' - ')}.xlsx`.toUpperCase();
    },
    defaultDateRange() {
      const tomorow = addDays(new Date(),1);
      const sevenDaysBefore = subDays(new Date(), 7);
      return [format(sevenDaysBefore, 'YYYY-MM-DD'), format(tomorow, 'YYYY-MM-DD')];
    },
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
    queriedData() {
      let result = this.feedbacks;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = []
        }
      }
      return result;
    },
  },
  methods: {
    showDetails(order) {
      this.selectedFeedback = order;
    },
    async loadFeedback() {
      const path = this.host + '/api/v3/foodcourt/feedbacks'
      this.isLoading = true;
      let response = await BackofficeApi.get(
        path,
        {
          params: {
            dark_kitchen_id: this.$store.getters.getKitchenId,
            range: this.rangeDate,
          }
        }
      );
      this.feedbacks = response.data["detail"]["feedbacks"];
      this.isLoading = false;
      this.loaded = true;
    },
    async downloadExcel() {
      const path = this.host + '/api/v3/foodcourt/feedbacks/export'
      this.isLoading = true;
      let response = await BackofficeApi.get(
        path,
        {
          params: {
            "page": 1,
            "office": 0,
            "dark_kitchen_id": this.$store.getters.getKitchenId,
            "date": "",
            "range": this.rangeDate,
            "status": null,

          },
          responseType: "blob"
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.excelName);
      document.body.appendChild(link);
      link.click();
      this.isLoading = false;
    },
    sortChange({ prop, order }) {
      if (prop) {
        this.feedbacks.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.feedbacks.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
    dateRangeChange(val) {
      const dates = val.split('a').map(item => {
        return item.trim()
      });
      dates.length === 2 ? this.rangeDate = dates : '';
    }
  },
  watch: {
    darkKitchenId(val) {
      if (!val) return;
      if (!this.loaded && !this.isLoading) {
        this.loadFeedback();
      }
    },
    async rangeDate(val) {
      if (this.loaded && !this.isLoading) {
        await this.loadFeedback();
      }
    },
    searchQuery(value) {
      this.fuseSearch = new Fuse(this.feedbacks, {
        keys: ['customer', 'branch_office', 'platos',],
        threshold: 0.3
      });
      let result = this.feedbacks;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: break-word !important;
}
</style>
